import { Controller } from "stimulus";
import { getActiveCurrency } from "../../util/currency";

// Trusted markets
const TRUSTED_MARKETS_MAP = {
  binance: true,
  bitfinex: true,
  bitstamp: true,
  bittrex: true,
  kraken: true,
  poloniex: true,
  bithumb: true,
  bitflyer: true
};

export default class extends Controller {
  static targets = ["tvSentiment", "copyright"]

  connect() {
    this.loadedTradingView = false
      const observer = new IntersectionObserver( (changes)=> {
        for (const change of changes) {
          if (this.loadedTradingView === true){
            return   
          }
          if (change.isIntersecting === false) {
            return
          }

          this.loadedTradingView = true

          if (this._tvLoadPromise && !forceReload) {
            return this._tvLoadPromise;
          }

          const coinApiSymbol = this.tvSentimentTarget.getAttribute("data-coin-api-symbol");

          return fetch(`https://api.coingecko.com/api/v3/coins/${coinApiSymbol}?localization=false`)
            .then(response => response.json())
            .then(res => {
              const currencyCode = getActiveCurrency();

              // Try to pick (1) tickers from trusted exchange (2) ticker with matching target as active currency
              const tickersInSupportedExchanges = [];
              const tickersWithTargetCurrency = [];
              res.tickers.forEach(t => {
                if (TRUSTED_MARKETS_MAP[t.market.name.toLowerCase()]) {
                  tickersInSupportedExchanges.push(t);

                  // Note: Allow USDT to be considered if its USD
                  if (currencyCode.toUpperCase() == "USD") {
                    if (t.target === "USDT") {
                      tickersWithTargetCurrency.push(t);
                    }
                  }
                  if (t.target === currencyCode.toUpperCase()) {
                    tickersWithTargetCurrency.push(t);
                  }
                }
              });
              const ticker = tickersWithTargetCurrency[0] || tickersInSupportedExchanges[0];
              return ticker
            })
            .then((ticker) => {
              var js = document.createElement("script");
              js.src = "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js"
              js.innerHTML = JSON.stringify({
                "showIntervalTabs": true,
                "width": 350,
                "colorTheme": "light",
                "isTransparent": true,
                "locale": "en",
                "symbol": `${ticker.market.name.toUpperCase()}:${ticker.base}${ticker.target}`,
                "interval": "15m",
                "height": 380
              })
              js.onerror = function () {
                console.error("Failed to load script:", src);
              };
              this.tvSentimentTarget.appendChild(js);
              this.copyrightTarget.innerHTML = "Technical Analysis by TradingView";
            });
          }
      });
      observer.observe(document.querySelector('#tradingview-sentiment'),{
        delay: 100
      });
  }
}
